export default "__VITE_ASSET__30ebcff8__"